import React from 'react';
import { ScrollView } from 'react-native';
import {
  DataTable, IconButton, List, Text,
} from 'react-native-paper';
import { useNavigation } from '@react-navigation/native';
import { SCREEN_NAMES } from '../../../utils/constant';
import LoadingIndicator from '../../../components/commons/LoadingIndicator';
import UserAvatarBadge from '../../../components/commons/UserAvatarBadge';
import useDesktopLayout from '../../../hooks/useDesktopLayout';

function SuperAdminsTab({ users, searchQuery, loading }) {
  const navigation = useNavigation();
  const isDesktop = useDesktopLayout();

  const admins = users
    .filter((u) => u.role === 'SUPERADMIN')
    .filter((u) => u.firstName?.toLowerCase().includes(searchQuery)
      || u.lastName?.toLowerCase().includes(searchQuery));

  return (
    <>
      {loading && <LoadingIndicator text="Chargement..." />}
      <ScrollView style={{ flex: 1 }}>
        {isDesktop ? (
          <DataTable>
            <DataTable.Header>
              <DataTable.Title>{' '}</DataTable.Title>
              <DataTable.Title>Nom</DataTable.Title>
              <DataTable.Title>Email</DataTable.Title>
              <DataTable.Title numeric>Actions</DataTable.Title>
            </DataTable.Header>
            {admins.map((d) => (
              <DataTable.Row key={d.id}>
                <DataTable.Cell><UserAvatarBadge user={d} icon="crown" /></DataTable.Cell>
                <DataTable.Cell>{`${d.firstName} ${d.lastName}`}</DataTable.Cell>
                <DataTable.Cell>{d.email}</DataTable.Cell>
                <DataTable.Cell numeric>
                  <IconButton
                    icon="eye"
                    onPress={() => navigation.navigate({ name: SCREEN_NAMES.PROFILE, params: { email: d.email } })}
                  />
                </DataTable.Cell>
              </DataTable.Row>
            ))}
          </DataTable>
        ) : (
          admins.map((d) => (
            <List.Item
              key={d.id}
              title={`${d.firstName} ${d.lastName}`}
              description={d.email}
              left={(props) => <UserAvatarBadge user={d} icon="crown" style={props.style} />}
              right={(props) => (
                <IconButton
                  {...props}
                  icon="eye"
                  onPress={() => navigation.navigate({ name: SCREEN_NAMES.PROFILE, params: { email: d.email } })}
                />
              )}
            />
          ))
        )}
        {admins.length === 0 && !loading && (
          <Text style={{ textAlign: 'center', marginTop: 32, opacity: 0.5 }}>
            Aucun administrateur trouvé
          </Text>
        )}
      </ScrollView>
    </>
  );
}

export default SuperAdminsTab;
